import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { downloadFile, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const LABELS = { csv: "CSV (.csv)", xlsx: "Excel (.xlsx)", json: "JSON (.json)", accdb: "Microsoft Access (.accdb)", wdb: "Microsoft Works (.wdb)" };

export default function ExportMenu({ path, formats, name, testId, label = "Export" }) {
  const [busy, setBusy] = useState(false);
  const { can } = useAuth();
  const run = async (format) => {
    setBusy(true);
    try {
      await downloadFile(path, { format }, `${name}.${format}`);
      toast.success(`Downloaded ${LABELS[format]}`);
    } catch (e) {
      toast.error(formatError(e));
    } finally {
      setBusy(false);
    }
  };
  if (!can("export")) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" disabled={busy} data-testid={testId} className="hover:bg-secondary hover:text-foreground">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <Download size={16} />} {label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-card">
        {formats.map((f) => (
          <DropdownMenuItem key={f} onClick={() => run(f)} data-testid={`${testId}-${f}`}>{LABELS[f]}</DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
